import React, { useContext, useEffect, useState } from "react";
import walletamount from "../../assets/images/wallet_amount.png";
import virtualamount from "../../assets/images/virtual_amount.png";
import upiamount from "../../assets/images/upi_amount.png";
import totalmember from "../../assets/images/userslogo.svg"
import { getAepsTreeBalance, getMainTreeBalance, getUserCount, getUsersData, getsettlementBalance } from "../../utils/api";
import { isEmpty } from "../../utils/common";
import { useSelector } from "react-redux";
import { UserContextData } from "../../App";
import { AmountCard } from "../Dashboard/VenderBalance";


export default function AmountOverview() {

    const [usersData, setUsersData] = useState('');
    const [treeBalanceAeps, setTreebalanceAeps] = useState('');
    const [treeBalanceMain, setTreebalanceMain] = useState('');
    const [loginUserType, setLoginUserTye] = useState("");
    const [countUser, setCountUser] = useState("");

    const userUpdate = useContext(UserContextData)
    useEffect(() => {
        getMainTreeBalance().then((resp) => {
            if (resp?.data?.success) {
                setTreebalanceMain(resp?.data?.data?.MAIN_WALLET)
            }

        });

        getAepsTreeBalance().then((resp) => {
            if (resp?.data?.success) {

                setTreebalanceAeps(resp?.data?.data?.AEPS_WALLET)

            }

        });


    }, [userUpdate])

    const { user } = useSelector((state) => state.user);



    useEffect(() => {

        if ((loginUserType === "") && !isEmpty(user?.userType)) {
            setLoginUserTye(user?.userType);

        }

    }, [user])




    useEffect(() => {
        if (!user?.userType) return;
        if (user?.userType == "ROLE_ADMIN") {
            getUserCount(user?.userType).then((resp) => {
                if (resp?.data?.success) {


                    setCountUser(resp?.data?.data);
                }


            });
        } else {
            getUsersData(user?.userType).then((resp) => {
                if (resp?.data?.success) {
                    const data = resp?.data?.data;

                    setCountUser({ userCount: data?.activeUsers });

                }


            });
        }




    }, [user])

    return (
        <div className="amount_overview">
            <AmountCard img={walletamount} title="Main Wallet Amount" amount={treeBalanceMain} />
            <AmountCard img={virtualamount} title="AEPS Wallet Amount" amount={treeBalanceAeps} />
            <AmountCard img={totalmember} title="Total Active Users" amount={countUser?.userCount} count={true} />
            {/* <AmountCard img={totalmember} title="Total Active Retailers" amount={usersData.activeUsers} count={true}  />
            <AmountCard img={totalmember} title="Total Inactive Retailers" amount={usersData.inactiveUsers}  count={true} /> */}
        </div>
    )
}